import React from "react";
import { Link } from "react-router-dom";
import SectionChip from "./SectionChip";
import { sendEvent } from "../../service/ragSearch";

const KIND_LABEL = { series: "Series", category: "Category", concept: "Topic" };

function toPath(item) {
  const id = item.permalink ?? item.id;
  if (item.kind === "concept") return `/concept/${id}`;
  return item.kind === "series" ? `/series/${id}` : `/category/${id}`;
}

export default function RagCollections({ collections, requestId }) {
  const list = collections || [];
  if (list.length === 0) return null;
  // Collection/concept cards are the most-clicked elements for topical queries —
  // report them like class clicks so the feedback loop sees real engagement.
  const reportClick = (item) => {
    if (requestId) {
      sendEvent({ request_id: requestId, kind: "click", target: `${item.kind}:${item.id}` });
    }
  };
  return (
    <section className="mb-8">
      <h2 className="text-[22px] md:text-2xl font-extrabold text-primaryDark mb-4">
        Start here
      </h2>
      <div className="space-y-3">
        {list.map((item) => (
          <Link
            key={`${item.kind}-${item.id}`}
            to={toPath(item)}
            onClick={() => reportClick(item)}
            className="flex items-center gap-3 rounded-lg bg-[#D2D6DC] bg-opacity-[0.4] p-4 hover:bg-opacity-[0.6] transition"
          >
            <span className="shrink-0 rounded bg-primaryBlue text-white text-xs px-2 py-1">
              {KIND_LABEL[item.kind] || item.kind}
            </span>
            <SectionChip section={item.section} />
            <span className="font-bold text-primaryDark flex-1">{item.title}</span>
            {typeof item.class_count === "number" && item.class_count > 0 && (
              <span className="text-sm text-primaryDark opacity-70">
                {item.class_count} classes
              </span>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
}
